export default __webpack_public_path__ + "static/media/noAttributes.57d8972f.png";